var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('headIndex'),_c('indexDynamic'),_c('indexResearch'),_c('indexAlumnus'),_c('indexGraduate'),_c('footerIndex')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }